/* Consentement produit numérique dans le panier (tiroir + page). Voir snippets/mi-cart-consent.liquid.
   - Accord enregistré dans les attributs du panier (POST /cart/update.js), donc visible sur la commande dans l'admin Shopify et lisible dans les notifications ({{ attributes[...] }}).
   - « Passer commande » reste cliquable : sans accord, message sous la case, focus sur la case, aucun passage au paiement.
   - Case décochée ou plus aucun produit numérique dans le panier : l'attribut est retiré. */
const KEY = 'Consentement produit numérique';
const VALUE = 'Oui, accès immédiat demandé et renonciation au droit de rétractation';
const SEL_BOX = '[data-mi-consent-box]';

const hasDigital = (cart) => ((cart && cart.items) || []).some((i) => i.requires_shipping === false);
const attrOf = (cart) => (cart && cart.attributes && cart.attributes[KEY]) || '';

async function getCart() {
  const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  return res.json();
}
async function setAttr(on) {
  const res = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { [KEY]: on ? VALUE : '' } }) });
  if (!res.ok) throw new Error('consent');
  return res.json();
}

const boxes = () => Array.from(document.querySelectorAll(SEL_BOX));
function setError(box, show) {
  const wrap = box.closest('[data-mi-consent]'); const out = wrap && wrap.querySelector('[data-mi-consent-error]');
  if (!out) return;
  out.textContent = show ? out.dataset.message : '';
  if (show) box.setAttribute('aria-invalid', 'true'); else box.removeAttribute('aria-invalid');
}
function syncBoxes(on, except) {
  boxes().forEach((b) => { if (b !== except) b.checked = on; if (on) setError(b, false); });
}

/* Case cochée ou décochée : enregistrement immédiat (l'état survit au rechargement et à la réinjection du bloc) */
let queue = Promise.resolve();
document.addEventListener('change', (e) => {
  const box = e.target.closest && e.target.closest(SEL_BOX);
  if (!box) return;
  const on = box.checked;
  syncBoxes(on, box); setError(box, false);
  queue = queue.then(() => setAttr(on)).catch(() => { box.checked = !on; syncBoxes(!on, box); });
});

/* « Passer commande » : bloqué tant que l'accord manque ; sinon l'accord est écrit puis le paiement s'ouvre normalement */
document.addEventListener('click', (e) => {
  const btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
  if (!btn) return;
  const form = btn.form || btn.closest('form');
  const box = form && form.querySelector(SEL_BOX);
  if (!box) return;   // panier sans produit numérique : comportement natif
  e.preventDefault(); e.stopImmediatePropagation();
  if (!box.checked) {
    setError(box, true);
    box.scrollIntoView({ block: 'center', behavior: 'auto' });
    box.focus({ preventScroll: true });
    return;
  }
  if (btn.getAttribute('aria-busy') === 'true') return;
  btn.setAttribute('aria-busy', 'true');
  queue = queue.then(() => setAttr(true)).then(() => {
    const go = document.createElement('input'); go.type = 'hidden'; go.name = 'checkout'; go.value = ''; form.appendChild(go);
    HTMLFormElement.prototype.submit.call(form);
  }).catch(() => { btn.removeAttribute('aria-busy'); setError(box, false); });
}, true);

/* Le panier change (ajout, retrait) : sans produit numérique, l'accord est retiré ; sinon l'état coché suit l'attribut */
function reconcile(cart) {
  if (!hasDigital(cart)) { if (attrOf(cart)) queue = queue.then(() => setAttr(false)).catch(() => {}); return; }
  syncBoxes(!!attrOf(cart));
}
document.addEventListener('mi:cart', (e) => reconcile(e.detail));
getCart().then(reconcile).catch(() => {});
window.addEventListener('pageshow', (e) => { if (e.persisted) getCart().then(reconcile).catch(() => {}); });
